import Loadable from '@townsquare/loadable';
import {
	aggGoalDirectoryArchivedRoute,
	aggGoalDirectoryFollowingRoute,
	aggGoalDirectoryRoute,
} from '@townsquare/routes/agg-goal-directory-view';
import { tqlExplainerGoalAggResource } from '@townsquare/tql/agg/resource/goal-explainer';

import { goalDirectoryAggResource } from './resources/goal-directory-agg';
import { goalDirectoryTableAggResource } from './resources/goal-directory-table-agg';

const GoalsDirectoryAggLoadable = Loadable({
	loader: () =>
		import(/* webpackChunkName: "agg-goals-directory-view" */ './components/GoalsDirectoryAgg'),
	loading: () => null,
});

aggGoalDirectoryRoute.component = GoalsDirectoryAggLoadable;
aggGoalDirectoryRoute.relayEnvironment = 'agg';
aggGoalDirectoryRoute.resources = [
	goalDirectoryAggResource,
	goalDirectoryTableAggResource,
	tqlExplainerGoalAggResource,
];

aggGoalDirectoryFollowingRoute.component = GoalsDirectoryAggLoadable;
aggGoalDirectoryFollowingRoute.relayEnvironment = 'agg';
aggGoalDirectoryFollowingRoute.resources = [
	goalDirectoryAggResource,
	goalDirectoryTableAggResource,
	tqlExplainerGoalAggResource,
];

aggGoalDirectoryArchivedRoute.component = GoalsDirectoryAggLoadable;
aggGoalDirectoryArchivedRoute.relayEnvironment = 'agg';
aggGoalDirectoryArchivedRoute.resources = [
	goalDirectoryAggResource,
	goalDirectoryTableAggResource,
	tqlExplainerGoalAggResource,
];

export const aggGoalDirectoryRouterRoute: typeof aggGoalDirectoryRoute = aggGoalDirectoryRoute;
export const aggGoalDirectoryFollowingRouterRoute: typeof aggGoalDirectoryFollowingRoute =
	aggGoalDirectoryFollowingRoute;
export const aggGoalDirectoryArchivedRouterRoute: typeof aggGoalDirectoryArchivedRoute =
	aggGoalDirectoryArchivedRoute;
